export const ingredientUnits = [
  "Bag",
  "Barrel",
  "Bottle",
  "Box",
  "Bucket",
  "Can",
  "Container",
  "Crate",
  "Cup",
  "Dozen",
  "Fluid ounce",
  "Grams",
  "Gallon",
  "Jar",
  "Jug",
  "Keg",
  "KiloGram",
  "Liter",
  "Ounce",
  "Pound",
  "Tank",
  "Tablespoon",
  "Teaspoon",
  "Ton",
  "Tub",
  "Pouch",
  "Set",
  "Sack",
];
//export const pullStrategy = ["FIFO", "Hand Pick", "FEFO", "LIFO"];
export const pullStrategy = ["FIFO", "Hand Pick", "FEFO", "LIFO"].sort();

const PULL_STRATEGY_LOOKUP = {
  fifo: "FIFO",
  fefo: "FEFO",
  lifo: "LIFO",
  "hand pick": "Hand Pick",
};

export const normalizePullStrategy = (value) => {
  if (value == null || value === "") {
    return "FIFO";
  }
  const trimmed = String(value).trim();
  const normalized = PULL_STRATEGY_LOOKUP[trimmed.toLowerCase()];
  return normalized || trimmed;
};

export const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const weekDays = [
  { key: "Monday", value: 2 },
  { key: "Tuesday", value: 3 },
  { key: "Wednesday", value: 4 },
  { key: "Thursday", value: 5 },
  { key: "Friday", value: 6 },
  { key: "Saturday", value: 7 },
  { key: "Sunday", value: 1 },
];

export const ingredientType = {
  default: "0",
  parts: "Part",
  percentage: "Percentage",
  type: "Type",
  measurement: "Measurement",
};

export const recipeSourceList = [
  { key: 1, name: "employee" },
  { key: 2, name: "other" },
];

export const planTypeSuccessMessage = {
  freePlanMessage: "Your free trial has been started successfully.",
  standardPlanMessage: "Your standard plan has been started successfully.",
  proPlanMessage: "Your pro plan has been started successfully.",
};

export const planText = {
  freePlan: 1,
  standardPlanMonthly: 2,
  standardPlanYearly: 4,
  proPlanMonthly: 3,
  proPlanYearly: 5,
};

export const basicPlan = {
  freePlan: 1,
  standardPlan: 2,
  proPlan: 3,
};

export const planName = {
  freePlan: "Free Blueberry Pie",
  standardPlan: "Hot Blueberry Pie",
  proPlan: "Hot Blueberry Pie Pro",
};

export const permission = {
  allAccess: 1, // edit => add edit view delete (All)
  view: 2,
  edit: 3,
  delete: 4,
  noAccess: 5,
};

export const newPermission = [
  { key: 1, value: "All Access" },
  { key: 2, value: "No Access" },
  { key: 3, value: "View Only" },
  { key: 4, value: "Custom Access" },
];

export const certificateByTime = [
  { key: "Expired", value: "Expired" },
  { key: "AboutToExpired", value: "About To Expired" },
  { key: "Active", value: "Active" },
];

export const certificateType = [
  { key: "all", value: "All" },
  { key: "companyProductionUnit", value: "Locations" },
  { key: "manufacturer", value: "Manufacturer" },
  { key: "coPacker", value: "Co-Packer" },
  { key: "ingredient", value: "Ingredient" },
];

export const newPermissionValue = {
  allAccess: 1, // Admin – add, edit, delete
  noAccess: 5, // None – hide / block module
  viewOnly: 2, // View only – no mutate
  customAccess: 3, // View & Edit – edit existing records only (no add)
  /** Alias for id 3 – View & Edit (same as customAccess) */
  viewEdit: 3,
};

/** Coerce API/route permission values to a number. */
export const toPermissionId = (permissionId) => Number(permissionId);

/**
 * Module visible / openable (not None).
 * isCheck + sidebar/route gates still use noAccess separately.
 */
export const hasModulePermission = (permissionId) => {
  const p = toPermissionId(permissionId);
  return Number.isFinite(p) && p !== newPermissionValue.noAccess;
};

/** Admin only – create / add new records. */
export const canAddWithPermission = (permissionId) =>
  toPermissionId(permissionId) === newPermissionValue.allAccess;

/**
 * Admin or View & Edit – change existing records.
 * View Only cannot edit.
 */
export const canEditWithPermission = (permissionId) => {
  const p = toPermissionId(permissionId);
  return (
    p === newPermissionValue.allAccess ||
    p === newPermissionValue.customAccess ||
    p === newPermissionValue.viewEdit
  );
};

/** Admin only – delete / destructive (same as previous allAccess gates). */
export const canDeleteWithPermission = (permissionId) =>
  toPermissionId(permissionId) === newPermissionValue.allAccess;

/** Full admin access (add + edit + delete). */
export const hasAllAccessPermission = (permissionId) =>
  toPermissionId(permissionId) === newPermissionValue.allAccess;

export const moduleIds = [
  //weightandMeasure:
  14,
  //plan_detail
  22,
];

export const permissionLevel = {
  mainMenu: "mainMenu",
  module: "module",
  options: "options",
  subModule: "subModule",
  fields: "fields",
};

export const permissionMessage = {
  noAccess: "You have no access to open the page.",
};

export const refType = {
  productionLocation: "companyProductionUnit",
  manufacturer: "manufacturer",
  coPacker: "coPacker",
};

export const unitType = {
  weight: 1,
  volume: 2,
  length: 5,
};

export const employeeType = {
  employee: 1,
  employedBy: 2,
  independentContractor: 3,
};

export const loginUserType = {
  admin: "admin",
  employee: "employee",
  superadmin: "superadmin",
};

export const modulesNotIncluded = [
  "Dashboard",
  // "Weights and Measures",
  "Reports",
  "Plan Details",
];

export const inspectionTabType = {
  past: "past",
  upcoming: "upcoming",
  directory: "directory",
  pending: "upcoming",
  inProcess: "inProcess",
  complete: "complete",
  all: "all"
};

//id of the gram from fbt/api/unit/unit-list api response
export const gramUnit = {
  GRAMUNIT: 72,
};

export const ALLOCATED_FOR = {
  AVAILABLE: "Available",
  QUARANTINED: "Quarantined",
  DAMAGED: "Damaged",
};

// Labels for allocation type column and Tool drawer (all allocation row types)
export const ALLOCATION_TYPE_LABELS = {
  AVAILABLE: "Available",
  ALLOCATED: "Allocated",
  QUARANTINED: "Quarantined",
  DAMAGED: "Damaged",
  CONSUMED: "Consumed",
  ADJUSTED: "Adjustment (audit)",
  DISPOSED: "Disposed (audit)",
  REMOVED_FROM_QUARANTINE: "Removed from quarantine (audit)",
  REMOVED_FROM_DAMAGE: "Removed from damage (audit)",
};

// Types that represent live stock you can operate on (adjust, allocate, move, etc.)
export const LIVE_ALLOCATION_TYPES = ["AVAILABLE", "ALLOCATED", "QUARANTINED", "DAMAGED"];

// Types that are allowed to run Tool Page operations (we don't allow operations on ALLOCATED rows)
export const OPERABLE_ALLOCATION_TYPES = ["AVAILABLE", "QUARANTINED", "DAMAGED"];

// Tag color per allocation type (Ant Design Tag colors): live = distinct, audit = visible but muted
export const ALLOCATION_TYPE_TAG_COLOR = {
  AVAILABLE: "green",
  ALLOCATED: "blue",
  QUARANTINED: "orange",
  DAMAGED: "red",
  CONSUMED: "volcano",
  ADJUSTED: "purple",
  DISPOSED: "purple",
  REMOVED_FROM_QUARANTINE: "purple",
  REMOVED_FROM_DAMAGE: "purple",
};

export const productionRunModalType = {
  allocate: "Allocate",
  deallocate: "Deallocate",
  remaining: "Remaining",
};

/** Production run source type (RECIPE | ASSEMBLY) */
export const PRODUCTION_SOURCE_TYPE = {
  RECIPE: "RECIPE",
  ASSEMBLY: "ASSEMBLY",
};

/** Labels for production/assembly component types (preview, allocate, remaining) */
export const PRODUCTION_COMPONENT_TYPE_LABELS = {
  INGREDIENT: "Ingredient",
  BASIC_MATERIAL: "Material",
  FINISHED_GOOD: "Finished Good",
  ASSEMBLY: "Sub-Assembly",
};

export const TOOL_PAGE_FIELD = {
  USE: ["useMaterialQty", "usedMaterialFor"],
  ALLOCATE: ["change_allocation", "projectName"],
  CHANGE_LOCATION: ["locQty", "location", "destinationBin"],
  CHANGE_OWNER: ["change_owner_quantity", "owner"],
  ADJUST: ["adjust_quantity", "type", "adjustDestinationBin"],
  ADD_TO_QUARANTINE: ["addQuarantineQuantity"],
  ADD_TO_DAMAGE: ["addDamageQuantity"],
  REMOVE_FROM_QUARANTINE: ["rmQurQuantity"],
  REMOVE_FROM_DAMAGE: ["removeDamagedQuantity"],
  DISPOSE: ["disposeQuantity"],
};

export const CUSTOMER_TYPE = {
  Retailer: "Retail",
  Wholesaler: "Wholesale",
  ECommerce: "e-Commerce",
  CoManufacturing: "Co-Manufacturing",
  Online: "Online",
};


export const SAFETY_TYPE=["SDS","MSDS", "TDS"];

/** Customer order item types - must match backend CustomerOrderItemType enum names */
export const CUSTOMER_ORDER_ITEM_TYPE = {
  FINISHED_GOOD: "FINISHED_GOOD",
  INGREDIENT: "INGREDIENT",
  MATERIAL: "MATERIAL",
  SERVICE: "SERVICE",
};

export const CUSTOMER_ORDER_ITEM_TYPE_OPTIONS = [
  { value: CUSTOMER_ORDER_ITEM_TYPE.FINISHED_GOOD, label: "Finished Good" },
  { value: CUSTOMER_ORDER_ITEM_TYPE.INGREDIENT, label: "Ingredient" },
  { value: CUSTOMER_ORDER_ITEM_TYPE.MATERIAL, label: "Material" },
  { value: CUSTOMER_ORDER_ITEM_TYPE.SERVICE, label: "Service" },
];